/* eslint-disable prettier/prettier */
/* eslint-disable */
/* prettier-ignore-file */
import { FC, useEffect, useMemo, useState } from 'react';
import styles from '../../../styles/components/pageComponents/manageUsers/ManageUsers.module.css';
import { ReactComponent as AllUserIcon } from '../../../assets/profile/a.svg';
import { ReactComponent as LearnerIcon } from '../../../assets/profile/l.svg';
import { ReactComponent as InviteesIcon } from '../../../assets/profile/i.svg';
import view from '../../../assets/profile/View.png';
import edit from '../../../assets/profile/Edit.png';
import deletee from '../../../assets/profile/Delete.png';
import msg from '../../../assets/profile/Message.png';
import left from '../../../assets/profile/left.png';
import right from '../../../assets/profile/right.png';
import down from '../../../assets/profile/Vector (13).png';
import profileDefault from '../../../assets/profile/profile.svg';

export type UserRole = 'learner' | 'invitee' | 'coach' | 'guest' | null;
export interface Program {
	id: string;
	title: string;
	relationship: 'owner' | 'faculty';
}
export interface User {
	id: string;
	avatarUrl?: string;
	fullName: string;
	email?: string;
	enrolledProgram?: string;
	iccCredentials?: string;
	role: UserRole;
	programs?: Program[];
	//  enrollmentId: string;
	enrollmentIds?: string[];
	status?: string;
}

interface ManageUsersProps {
	users: User[];
	pageSize?: number;
	activeTab: TabType;
	setActiveTab: (tab: TabType) => void;
	onView?: (user: User) => void;
	onEdit?: (user: User) => void;
	onDelete?: (user: User) => void;
}

type TabType = 'all' | 'learner' | 'invitee' | 'coach' | 'guest';

const ManageUsersAdmin: FC<ManageUsersProps> = ({
	users,
	pageSize = 8,
	activeTab,
	setActiveTab,
	onView,
	onEdit,
	onDelete,
}) => {
	//   const [activeTab, setActiveTab] = useState<TabType>("all");
	const [currentPage, setCurrentPage] = useState(1);

	const [roleSortOrder, setRoleSortOrder] = useState<'asc' | 'desc' | null>(
		null
	);

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth <= 768);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	const sortedUsers = useMemo(() => {
		if (!roleSortOrder) return users;

		const rolePriority: Record<string, number> = {
			coach: 1,
			invitee: 2,
			guest: 3,
			learner: 4,
			'': 2,
		};

		return [...users].sort((a, b) => {
			const roleA = rolePriority[a.role ?? 'invitee'];
			const roleB = rolePriority[b.role ?? 'invitee'];

			if (roleSortOrder === 'asc') {
				return roleA - roleB;
			} else {
				return roleB - roleA;
			}
		});
	}, [users, roleSortOrder]);

	const handleRoleSort = () => {
		setCurrentPage(1);

		setRoleSortOrder(prev => {
			if (prev === 'asc') return 'desc';
			if (prev === 'desc') return 'asc';
			return 'asc';
		});
	};

	// 🔹 Pagination logic

	const totalPages = Math.ceil(sortedUsers.length / pageSize);

	const paginatedUsers = useMemo(() => {
		const start = (currentPage - 1) * pageSize;
		return sortedUsers.slice(start, start + pageSize);
	}, [sortedUsers, currentPage, pageSize]);

	const renderRole = (role: UserRole) => {
		if (!role || role === 'invitee') {
			return <span className={styles.invitee}>Invitee</span>;
		}

		if (role === 'guest') {
			return <span className={styles.invitee}>Guest</span>;
		}

		if (role === 'learner') {
			return <span className={styles.learner}>Learner</span>;
		}

		if (role === 'coach') {
			return <span className={styles.coach}>Coach</span>;
		}

		return <span className={styles.defaultRole}>{role}</span>;
	};

	const getPageNumbers = () => {
		const pages: (number | string)[] = [];

		if (totalPages <= 5) {
			return Array.from({ length: totalPages }, (_, i) => i + 1);
		}

		pages.push(1);

		if (currentPage > 3) {
			pages.push('left-ellipsis');
		}

		const start = Math.max(2, currentPage - 1);
		const end = Math.min(totalPages - 1, currentPage + 1);

		for (let i = start; i <= end; i++) {
			pages.push(i);
		}

		if (currentPage < totalPages - 2) {
			pages.push('right-ellipsis');
		}

		pages.push(totalPages);

		return pages;
	};

	const bottomUI = (
		<div className={styles.bottom}>
			{totalPages > 1 && (
				<div className={styles.pagination}>
					{totalPages > 5 && (
						<button
							disabled={currentPage === 1}
							onClick={() => setCurrentPage(p => p - 1)}
						>
							<img src={left} alt="Previous page" />
						</button>
					)}

					{getPageNumbers().map(page =>
						typeof page === 'string' ? (
							<span key={page} className={styles.ellipsis}>
								...
							</span>
						) : (
							<button
								key={page}
								className={
									currentPage === page
										? styles.activePage
										: ''
								}
								onClick={() => setCurrentPage(page)}
							>
								{page}
							</button>
						)
					)}

					{totalPages > 5 && (
						<button
							disabled={currentPage === totalPages}
							onClick={() => setCurrentPage(p => p + 1)}
						>
							<img src={right} alt="Next page" />
						</button>
					)}
				</div>
			)}

			<div className={styles.showingText}>
				Showing {paginatedUsers.length} of {users.length}
			</div>
		</div>
	);

	return (
		<div className={styles.container}>
			{/* {isMobile && bottomUI} */}
			{isMobile && sortedUsers.length > 0 && bottomUI}
			{/* Tabs */}

			<div className={styles.tabsWrapper}>
				<div className={styles.tabs}>
					<div
						className={`${styles.tab} ${activeTab === 'all' ? styles.activeTab : ''}`}
						onClick={() => {
							setActiveTab('all');
							setCurrentPage(1);
							setRoleSortOrder(null);
						}}
					>
						{/* <AllUserIcon className={styles.tabIcon} /> */}
						All Users
					</div>

					<div
						className={`${styles.tab} ${activeTab === 'learner' ? styles.activeTab : ''}`}
						onClick={() => {
							setActiveTab('learner');
							setCurrentPage(1);
							setRoleSortOrder(null);
						}}
					>
						{/* <LearnerIcon className={styles.tabIcon} /> */}
						Learner
					</div>

					<div
						className={`${styles.tab} ${activeTab === 'coach' ? styles.activeTab : ''}`}
						onClick={() => {
							setActiveTab('coach');
							setCurrentPage(1);
							setRoleSortOrder(null);
						}}
					>
						{/* <InviteesIcon className={styles.tabIcon} />  */}
						Coaches
					</div>

					<div
						className={`${styles.tab} ${activeTab === 'invitee' ? styles.activeTab : ''}`}
						onClick={() => {
							setActiveTab('invitee');
							setCurrentPage(1);
							setRoleSortOrder(null);
						}}
					>
						{/* <InviteesIcon className={styles.tabIcon} /> */}
						Invitees
					</div>

					<div
						className={`${styles.tab} ${activeTab === 'guest' ? styles.activeTab : ''}`}
						onClick={() => {
							setActiveTab('guest');
							setCurrentPage(1);
							setRoleSortOrder(null);
						}}
					>
						{/* <InviteesIcon className={styles.tabIcon} /> */}
						Guests
					</div>
				</div>
			</div>

			{/* Table */}
			{sortedUsers.length === 0 && (
				<div className={styles.emptyStateWrapper}>
					<div className={styles.emptyState}>
						<p className={styles.emptyTitle}>No users found</p>
						<p className={styles.emptySubtitle}>
							There are no users available.
						</p>
					</div>
				</div>
			)}
			{sortedUsers.length > 0 && (
				<div className={styles.table}>
					<div className={styles.header}>
						<div>Full Name</div>
						<div>Program</div>
						<div>ICC Credentials</div>

						{activeTab === 'all' ? (
							<div
								className={styles.sortableHeader}
								onClick={handleRoleSort}
							>
								Role
								<img
									src={down}
									alt="sort"
									className={`${styles.sortIcon} ${
										roleSortOrder === 'asc'
											? styles.rotateUp
											: roleSortOrder === 'desc'
												? styles.rotateDown
												: ''
									}`}
								/>
							</div>
						) : (
							<div>Role</div>
						)}
						<div>Quick Actions</div>
					</div>

					{sortedUsers.length === 0 ? (
						<div className={styles.emptyState}>
							<p className={styles.emptyTitle}>
								No matching users found
							</p>
							<p className={styles.emptySubtitle}>
								Try adjusting your search or filters.
							</p>
						</div>
					) : (
						paginatedUsers.map(user =>
							isMobile ? (
								/* ✅ MOBILE CARD */
								<div key={user.id} className={styles.row}>
									<div className={styles.topRow}>
										<div className={styles.nameCell}>
											{/* <div className={styles.avatar}>
            {user.avatarUrl ? (
             
               <img
  src={user.avatarUrl || profileDefault}
  alt={user.fullName}
  onError={(e) => {
    const target = e.target as HTMLImageElement;
    target.onerror = null; // prevent infinite loop
    target.src = profileDefault;
  }}
/>
            ) : (
              <div className={styles.placeholderAvatar} />
            )}
          </div> */}
											<div
												className={styles.avatarWrapper}
											>
												<div className={styles.avatar}>
													<img
														src={
															user.avatarUrl ||
															profileDefault
														}
														alt={user.fullName}
														onError={e => {
															const target =
																e.target as HTMLImageElement;
															target.onerror =
																null;
															target.src =
																profileDefault;
														}}
													/>
												</div>

												{/* {(user.role === "invitee" || !user.role) && (
    <span className={styles.inviteeDot}></span>
  )} */}
												{(user.role === 'invitee' ||
													user.role === 'guest' ||
													!user.role) && (
													<span
														className={
															styles.inviteeDot
														}
													></span>
												)}
											</div>

											{/* <span className={styles.fullName}>{user.fullName}</span> */}
											<span
												className={`${styles.fullName} ${
													// user.role === "invitee" || !user.role ? styles.inviteeName : ""
													user.role === 'invitee' ||
													user.role === 'guest' ||
													!user.role
														? styles.inviteeName
														: ''
												}`}
											>
												{user.fullName}
											</span>
										</div>

										<div className={styles.actions}>
											{/* <div className={styles.tooltip}>
  <button
    className={styles.iconbtn}
    onClick={() => onView?.(user)}
    aria-label="View user"
  >
    <img src={view} alt="" />
  </button>
  <span className={styles.tooltipText}>View</span>
</div> */}
											{user.role !== 'invitee' &&
												user.role !== null && (
													<div
														className={
															styles.tooltip
														}
													>
														<button
															className={
																styles.iconbtn
															}
															onClick={() =>
																onView?.(user)
															}
															aria-label="View user"
														>
															<img
																src={view}
																alt=""
															/>
														</button>
														<span
															className={
																styles.tooltipText
															}
														>
															View
														</span>
													</div>
												)}

											<div className={styles.tooltip}>
												<button
													className={styles.iconbtn}
													aria-label="Send message"
												>
													<img src={msg} alt="" />
												</button>
												<span
													className={
														styles.tooltipText
													}
												>
													Message
												</span>
											</div>

											<div className={styles.tooltip}>
												<button
													className={styles.iconbtn}
													onClick={() =>
														onDelete?.(user)
													}
													aria-label="Delete user"
												>
													<img src={deletee} alt="" />
												</button>
												<span
													className={
														styles.tooltipText
													}
												>
													Delete
												</span>
											</div>

											{/* <div className={styles.tooltip}>
  <button
    className={styles.iconbtn}
    onClick={() => onEdit?.(user)}
    aria-label="Edit user"
  >
    <img src={edit} alt="" />
  </button>
  <span className={styles.tooltipText}>Edit</span>
</div> */}
										</div>
									</div>

									<div className={styles.detailBlock}>
										<div className={styles.label}>
											Program
										</div>
										{/* <div className={styles.value}>{user.enrolledProgram ?? "No program enrolled"}</div> */}
										<div className={styles.programCell}>
											{user.enrolledProgram ??
												'No program enrolled'}
										</div>
									</div>

									<div className={styles.detailBlock}>
										<div className={styles.label}>
											ICC Credentials
										</div>
										<div className={styles.value}>
											{user.iccCredentials ?? 'N/A'}
										</div>
									</div>

									{/* <div className={styles.detailBlock}>
        <div className={styles.label}>Role</div>
        {renderRole(user.role)}
      </div> */}
								</div>
							) : (
								/* ✅ DESKTOP TABLE ROW */
								<div key={user.id} className={styles.row}>
									<div className={styles.nameCell}>
										{/* <div className={styles.avatar}>
          {user.avatarUrl ? (
            
            <img
  src={user.avatarUrl || profileDefault}
  alt={user.fullName}
  onError={(e) => {
    const target = e.target as HTMLImageElement;
    target.onerror = null; // prevent infinite loop
    target.src = profileDefault;
  }}
/>
          ) : (
            <div className={styles.placeholderAvatar} />
          )}
        </div> */}
										<div className={styles.avatarWrapper}>
											<div className={styles.avatar}>
												<img
													src={
														user.avatarUrl ||
														profileDefault
													}
													alt={user.fullName}
													onError={e => {
														const target =
															e.target as HTMLImageElement;
														target.onerror = null;
														target.src =
															profileDefault;
													}}
												/>
											</div>

											{/* {(user.role === "invitee" || !user.role) && (
    <span className={styles.inviteeDot}></span>
  )} */}
											{(user.role === 'invitee' ||
												user.role === 'guest' ||
												!user.role) && (
												<span
													className={
														styles.inviteeDot
													}
												></span>
											)}
										</div>

										{/* <span className={styles.fullName}>{user.fullName}</span> */}
										<span
											className={`${styles.fullName} ${
												// user.role === "invitee" || !user.role ? styles.inviteeName : ""
												user.role === 'invitee' ||
												user.role === 'guest' ||
												!user.role
													? styles.inviteeName
													: ''
											}`}
										>
											{user.fullName}
										</span>
									</div>

									{/* <div>{user.enrolledProgram ?? "No program enrolled"}</div> */}
									<div className={styles.programCell}>
										{user.enrolledProgram ??
											'No program enrolled'}
									</div>
									<div>{user.iccCredentials ?? 'N/A'}</div>
									<div>{renderRole(user.role)}</div>

									<div className={styles.actions}>
										{/* <div className={styles.tooltip}>
  <button
    className={styles.iconbtn}
    onClick={() => onView?.(user)}
    aria-label="View user"
  >
    <img src={view} alt="" />
  </button>
  <span className={styles.tooltipText}>View</span>
</div> */}
										{/* {user.role !== "invitee" && user.role !== null && (
  <div className={styles.tooltip}>
    <button
      className={styles.iconbtn}
      onClick={() => onView?.(user)}
      aria-label="View user"
    >
      <img src={view} alt="" />
    </button>
    <span className={styles.tooltipText}>View</span>
  </div>
)} */}
										<div className={styles.tooltip}>
											<button
												className={styles.iconbtn}
												onClick={() => {
													if (
														user.role !==
															'invitee' &&
														user.role !== null
													) {
														onView?.(user);
													}
												}}
												aria-label="View user"
												disabled={
													user.role === 'invitee' ||
													user.role === null
												}
											>
												<img src={view} alt="" />
											</button>
											{/* <span className={styles.tooltipText}>View</span> */}
											<span
												className={styles.tooltipText}
											>
												{user.role === 'invitee' ||
												user.role === null
													? 'View not available'
													: 'View'}
											</span>
										</div>
										<div className={styles.tooltip}>
											<button
												className={styles.iconbtn}
												aria-label="Send message"
											>
												<img src={msg} alt="" />
											</button>
											<span
												className={styles.tooltipText}
											>
												Message
											</span>
										</div>
										{/* <div className={styles.tooltip}>
  <button
    className={styles.iconbtn}
    onClick={() => onEdit?.(user)}
    aria-label="Edit user"
  >
    <img src={edit} alt="" />
  </button>
  <span className={styles.tooltipText}>Edit</span>
</div> */}

										<div className={styles.tooltip}>
											<button
												className={styles.iconbtn}
												onClick={() => onDelete?.(user)}
												aria-label="Delete user"
											>
												<img src={deletee} alt="" />
											</button>
											<span
												className={styles.tooltipText}
											>
												Delete
											</span>
										</div>
									</div>
								</div>
							)
						)
					)}
				</div>
			)}

			{!isMobile && sortedUsers.length > 0 && (
				<div className={styles.bottom}>
					{totalPages > 1 && (
						<div className={styles.pagination}>
							{totalPages > 5 && (
								<button
									disabled={currentPage === 1}
									onClick={() => setCurrentPage(p => p - 1)}
								>
									<img src={left} alt="Previous page" />
								</button>
							)}

							{getPageNumbers().map(page =>
								typeof page === 'string' ? (
									<span
										key={page}
										className={styles.ellipsis}
									>
										...
									</span>
								) : (
									<button
										key={page}
										className={
											currentPage === page
												? styles.activePage
												: ''
										}
										onClick={() => setCurrentPage(page)}
									>
										{page}
									</button>
								)
							)}

							{totalPages > 5 && (
								<button
									disabled={currentPage === totalPages}
									onClick={() => setCurrentPage(p => p + 1)}
								>
									<img src={right} alt="Next page" />
								</button>
							)}
						</div>
					)}

					<div className={styles.showingText}>
						Showing {paginatedUsers.length} of {users.length}
					</div>
				</div>
			)}
		</div>
	);
};

export default ManageUsersAdmin;
